import React, {useEffect, useState} from "react";
import {Button, Input} from "antd";
import {emailLogin, userInfo} from "../api/api";

import {EyeInvisibleOutlined, EyeOutlined} from '@ant-design/icons'; // v4版本的图标

const LoginPage = () => {
    const [email, setEmail] = useState("3636721357@qq.com");
    const [password, setPassword] = useState("123456");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [user, setUser] = useState(null); // 用来存储用户信息

    const [visible, setVisible] = useState(false); // 控制密码的可见性

    const togglePasswordVisibility = () => {
        setVisible(!visible); // 切换密码显示/隐藏
    };

    // 页面加载时检查是否有 token
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            getUserInfo(); // 如果有 token，尝试获取用户信息
        } else {
            setUser(null); // 没有 token 时清空 user 信息
        }
    }, []);  // 只在组件加载时执行一次

    const handleLogin = async () => {
        setLoading(true);
        setError("");

        try {
            const response = await emailLogin({ email, password });
            if (response.status === 0) {
                alert("登录成功");
                localStorage.setItem("token", response.data.token);
                getUserInfo(); // 登录成功后获取用户信息
            } else {
                setError(response.message || "登录失败");
            }
        } catch (err) {
            setError("登录请求失败，请稍后重试");
        } finally {
            setLoading(false);
        }
    };

    const getUserInfo = async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) return;

            const response = await userInfo();
            if (response.status === 0) {
                setUser(response.data); // 存储用户信息
            } else {
                setError(response.message || "获取用户信息失败");
            }
        } catch (err) {
            setError("获取用户信息请求失败，请稍后重试");
        }
    };

    const handleLogout = () => {
        localStorage.removeItem('token'); // 删除 token
        setUser(null); // 清空用户信息，触发重新渲染
    };

    // 如果已登录，则显示用户信息，否则显示登录表单
    return (
        <div>
            {user ? (
                // 显示用户信息
                <div>
                    <h2>欢迎，{user.nick_name}</h2>
                    <div>{JSON.stringify(user)}</div>
                    <Button onClick={handleLogout}>退出登录</Button>
                </div>
            ) : (
                // 显示登录表单
                <div>
                    <h2>登录</h2>
                    <div>
                        <label>邮箱</label>
                        <Input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <div>
                        <label>密码</label>
                        <Input
                            type={visible ? "text" : "password"} // 根据 visible 动态切换明文或密文
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            suffix={
                                <Button
                                    icon={visible ? <EyeOutlined/> : <EyeInvisibleOutlined/>}
                                    onClick={togglePasswordVisibility}
                                    type="link"
                                />
                            }
                        />
                    </div>
                    <div>
                        <Button onClick={handleLogin} disabled={loading}>
                            {loading ? "登录中..." : "登录"}
                        </Button>
                    </div>

                    {error && <p style={{ color: "red" }}>{error}</p>}
                </div>
            )}
        </div>
    );
};

export default LoginPage;
